import { useThree } from '@react-three/fiber'
import { Text } from '@react-three/drei'
import { useEffect, useState } from 'react'
import { useScreenSize } from '../hooks/useScreenSize'

export function Title({ text }) {
    const [fontSize, setFontSize] = useState(0.5)
    const { screenWidth, screenHeight } = useScreenSize()

    const state = useThree()
    const { width, height } = state.viewport.getCurrentViewport(state.camera, [0, 0, 10])
    const shared = {
        font: '/Inter-Regular.woff',
        letterSpacing: -0.1,
        color: 'white'
    }

    useEffect(() => {
        if (screenWidth < 640) {
            setFontSize(0.15)
        }
        if (screenWidth >= 640) {
            setFontSize(0.25)
        }
        if (screenWidth >= 768) {
            setFontSize(0.35)
        }
        if (screenWidth >= 1024) {
            setFontSize(0.45)
        }
        if (screenWidth >= 1280) {
            setFontSize(0.55)
        }
    }, [screenWidth, screenHeight])

    return (
        <>
            <Text
                children={text}
                anchorX="left"
                position={[-width / 2.5, -height / 15, 10]}
                fontSize={fontSize}
                {...shared}
            />
        </>
    )
}
